import React, { Component } from 'react';
import { Button, Form, Header, Icon, Segment } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import AnnouncementTable from './AnnouncementsTable';
import AnnouncementEdit from './AnnouncementEdit';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

class Announcement extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            data: [],
            roleOptions: [],
            roleFilter: 'all',
            showForm: false,
            editingRowData: null
        };
        this.fetchData = this.fetchData.bind(this);
        this.fetchRoles = this.fetchRoles.bind(this);
        this.handleRoleFilterChange = this.handleRoleFilterChange.bind(this);
        this.getFilteredData = this.getFilteredData.bind(this);
        this.onCloseForm = this.onCloseForm.bind(this);
    }

    componentDidMount() {
        this.fetchRoles();
        this.fetchData();
    }

    onCloseForm() {
        this.setState({
            showForm: false,
            editingRowData: null
        });
    }

    fetchData() {
        axios.get('/announcement/all')
            .then(res => {
                this.setState({ data: res.data.sort((a, b) => b.id - a.id) });
            })
            .catch(() => {
                this.setState({ data: [] });
            });
    }

    fetchRoles() {
        axios.get('/user-types')
            .then(res => {
                const isInternationalCooperationOffice = (localStorage.getItem('activeRole') || '')
                    .startsWith('Služba za međunarodnu saradnju');
                const allowedRoleKeys = [
                    'student',
                    'vicedean_for_international_cooperation',
                    'professor',
                    'assistant'
                ];
                const availableRoles = isInternationalCooperationOffice
                    ? res.data.filter(role => allowedRoleKeys.includes(role._key))
                    : res.data;
                const roleOptions = availableRoles
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(el => ({
                        key: el.id,
                        value: el.id,
                        text: el.name
                    }));

                this.setState({
                    roleOptions: [{
                        key: 'all',
                        value: 'all',
                        text: isInternationalCooperationOffice ? 'Svi primaoci' : 'Sve uloge'
                    }, ...roleOptions]
                });
            })
            .catch(() => {
                const isInternationalCooperationOffice = (localStorage.getItem('activeRole') || '')
                    .startsWith('Služba za međunarodnu saradnju');
                this.setState({
                    roleOptions: [{
                        key: 'all',
                        value: 'all',
                        text: isInternationalCooperationOffice ? 'Svi primaoci' : 'Sve uloge'
                    }]
                });
            });
    }

    handleRoleFilterChange(e, { value }) {
        this.setState({ roleFilter: value });
    }

    getFilteredData() {
        const isInternationalCooperationOffice = (localStorage.getItem('activeRole') || '')
            .startsWith('Služba za međunarodnu saradnju');
        const availableData = isInternationalCooperationOffice
            ? this.state.data.filter(announcement => (
                announcement.createdByRole === 'international_cooperation_office'
            ))
            : this.state.data;

        if (this.state.roleFilter === 'all') {
            if (isInternationalCooperationOffice) {
                const allowedRoleIds = this.state.roleOptions
                    .filter(option => option.value !== 'all')
                    .map(option => option.value);

                return availableData.filter(announcement => (
                    announcement.userTypes &&
                    announcement.userTypes.some(userType => allowedRoleIds.includes(userType.id))
                ));
            }

            return availableData;
        }

        return availableData.filter(announcement =>
            announcement.userTypes &&
            announcement.userTypes.some(userType => userType.id === this.state.roleFilter)
        );
    }

    render() {
        const filteredData = this.getFilteredData();
        const isInternationalCooperationOffice = (localStorage.getItem('activeRole') || '')
            .startsWith('Služba za međunarodnu saradnju');

        return (
            <div>
                <h1>{'Obavještenja'}</h1>
                <Segment.Group raised>
                    <Segment>
                        {localStorage.getItem('activeRole')
                            .substr(0, 10) !== 'Studentska' ?
                            <h3> Obavještenja
                                {!this.state.showForm && (
                                    <Header style={IconHeader} floated="right">
                                        <Button
                                            disabled={localStorage.getItem('activeRole') === 'Support'}
                                            color="blue"
                                            floated="right"
                                            icon
                                            labelPosition="right"
                                            size="small"
                                            style={FiltersOnStyle}
                                            onClick={() => this.setState({
                                                showForm: true,
                                                editingRowData: null
                                            })}
                                        >
                                            <Icon className="add"/>
                                            Kreiraj obavještenje
                                        </Button>
                                    </Header>
                                )}
                            </h3>
                            :
                            <h3> Obavještenja </h3>
                        }
                    </Segment>

                    {this.state.showForm && (
                        <AnnouncementEdit
                            announcement={this.state.editingRowData}
                            fetchData={this.fetchData}
                            onCloseForm={this.onCloseForm}
                        />
                    )}

                    <Segment>
                        <Form style={{ marginBottom: '16px' }}>
                            <Form.Dropdown
                                clearable={false}
                                label={isInternationalCooperationOffice
                                    ? 'Prikaži obavještenja za'
                                    : 'Uloga'}
                                name="roleFilter"
                                options={this.state.roleOptions}
                                value={this.state.roleFilter}
                                onChange={this.handleRoleFilterChange}
                                search
                                selection
                                width={6}
                            />
                        </Form>
                        <AnnouncementTable
                            data={filteredData}
                            fetchData={this.fetchData}
                            onEdit={(item) => this.setState({ showForm: true, editingRowData: item })}
                        />
                    </Segment>
                    <ToastContainer hideProgressBar/>
                </Segment.Group>
            </div>
        );
    }
}

export default Announcement;



// WEBPACK FOOTER //
// ./src/views/Admin/Announcements/Announcements.js